import {tee3getAccessToken, tee3getRoom, tee3getSelfUser, tee3init, tee3join, tee3LeaveRoom,tee3closeCameraAndPubVideo,tee3closeMicrophone,tee3openMicrophone,gettee3MicrophoneStatus,openCameraAndPubVideo,tee3videoStatus,tee3OpenScreenAndPub} from "./tee3";
import {isEmpty} from "../utils";

export const tee3bankmixin = {
    props: {

    },
    data() {
        return {
            currentBoardUserId:null,
            currentBoardId:null,
            currentBoard:null,
        }
    },
    created() {

    },
    beforeDestroy() {

    },
    methods: {
        getRoom(){
            const room = tee3getRoom();
            return isEmpty(room) ;
        },
        createBank(){
            if(this.getRoom())return this.$message.error('还未进入房间');
            const user = tee3getSelfUser();
            const boardWidth = 600;
            const boardHeight = 580;
            const backgroundColor = '105,105,105,1';
            console.log('0')
            console.log(user)
            const board = user.createBoard(boardWidth,boardHeight,backgroundColor,null);
            console.log('1')
            this.createBoardHandle(board);
        },
        createBoardHandle(board){
            const boardsDiv = this.$refs['whitebank'];
            this.currentBoardUserId = board.userId;
            this.currentBoardId = board.id;
            this.currentBoard = board;

            const newBoardDiv = document.createElement("Div");
            newBoardDiv.id = "board_" + board.id;
            newBoardDiv.style.width = board.width+"px";
            newBoardDiv.style.height = board.height+"px";
            newBoardDiv.style.position = 'relative';

            newBoardDiv.boardUserId = board.userId;
            newBoardDiv.boardId = board.id;

            newBoardDiv.ondblclick = function(){
               this.changBorad(this.boardUserId,this.boardId);
            };

            const newBoardCanvas = document.createElement("Div");
            newBoardCanvas.style.width = "100%";
            newBoardCanvas.style.height = "100%";
            newBoardCanvas.style.background = "rgba("+board.backgroundColor+")";
            newBoardCanvas.style.position = 'relative';

            const newBoardTagDiv = document.createElement("Div");
            newBoardTagDiv.innerHTML = board.userId+"_"+board.id;
            newBoardTagDiv.style.top = 5 + "px";
            newBoardTagDiv.style.left = 5 + "px";
            newBoardTagDiv.style.position = "absolute";
            newBoardTagDiv.style.zIndex = 100;
            newBoardTagDiv.style.color = '#fff';
            newBoardTagDiv.style.background = 'rgba(0,0,0,.5)';

            console.log(newBoardDiv)
            console.log(newBoardTagDiv)
            console.log(newBoardCanvas)
            //newBoardDiv.appendChild(newBoardTagDiv);
            newBoardDiv.appendChild(newBoardCanvas);
            console.log('2.1')
            console.log(boardsDiv)
            boardsDiv.appendChild(newBoardDiv);
            console.log('2')
            board.createAnnotation().then(function(annotation){
                annotation.init(newBoardCanvas)
                board.annotation.hlightPointInit('./icon-eraser.png',20,20);
                this.changBorad(board.userId,board.id);
            });
        },
        changBorad(boardUserId,boardId){
            const boardUser = tee3getRoom().getUser(boardUserId);
            if(boardUser){
                let board = boardUser.getBoard(boardId);
                this.currentBoardUserId = boardUserId;
                this.currentBoardId = boardId;
                this.currentBoard = board;
            }
        },
        removeBank(){
            if(this.currentBoardId && this.currentBoardUserId == tee3getSelfUser().id){
                tee3getSelfUser().removeBoardById(this.currentBoardId);
                this.removeBoardHandle(this.currentBoardId);
            }
        },
        removeBoardHandle(boardId){
            let removeBoardDivName = "board_" + boardId;
            let removeBoardsDiv = document.getElementById(removeBoardDivName);

            let boardsDiv = this.$refs['whitebank'];
            boardsDiv.removeChild(removeBoardsDiv);
            this.currentBoardUserId = null;
            this.currentBoardId = null;
            this.currentBoard = null;
        }
    }
}
